module.exports = __webpack_public_path__ + "img/icon-phone.a460cc68.svg";